<div class="sl-container">

  <!-- 頁籤 -->
  <ul class="nav nav-tabs sl-tabs">
    <li *ngFor="let item of menu_list" class="nav-item" (click)="choose(item.id)">
      <a onclick="return false;"
         [ngClass]="now==item.id?'active':''"
         class="nav-link"
         href="#">
        <i class="fas {{item.id=='0'?'fa-link':'fa-chart-bar'}} mr-1"></i>
        {{item.name}}
      </a>
    </li>
  </ul>

  <!-- ===== Tab 0：短網址設定 ===== -->
  <div *ngIf="now=='0'" class="sl-panel">
    <div class="sl-toolbar">
      <button
        (click)="open_add_modal()"
        class="btn btn-primary btn-sm sl-btn-add"
        data-toggle="modal"
        data-target=".bd-example-modal-lg">
        <i class="fas fa-plus mr-1"></i>新增設定
      </button>
      <select class="form-control form-control-sm sl-filter-select ml-2" style="width:auto;"
        [(ngModel)]="status_filter" (ngModelChange)="pageobj.page=0;init_list()">
        <option value="">全部</option>
        <option value="1">上架</option>
        <option value="0">下架</option>
        <option value="-1">刪除</option>
      </select>
    </div>

    <app-table-v2 [type]="1" [tcontent]="tcontent" [data]="data">
      <ng-template let-post #operation_dk>
        <div *ngIf="post.key == 'domain'" class="text-center">
          <a class="sl-url-link"
             [href]="'https://' + post.val.domain + '/' + post.val.serial_number + (post.val.link_text ? '/' + encodeLinkText(post.val.link_text) : '')"
             target="_blank">
            {{post.val.domain}}/{{post.val.serial_number}}{{post.val.link_text ? '/' + truncateLinkText(post.val.link_text) : ''}}
          </a>
        </div>
        <div *ngIf="post.key == 'gg'" class="sl-ops">
          <a href="javascript:void(0)" title="編輯"
             (click)="edit_data=post.val;act='0';updateEncodedLabel()"
             data-toggle="modal" data-target=".bd-example-modal-lg">
            <i class="fas fa-edit text-primary"></i>
          </a>
          <a href="javascript:void(0)" title="查看報表"
             (click)="view_daily(post.val.id)">
            <i class="fas fa-chart-line text-success"></i>
          </a>
          <a href="javascript:void(0)" title="複製連結"
             (click)="copyLink(post.val)">
            <i class="fas fa-copy text-secondary"></i>
          </a>
        </div>
      </ng-template>
    </app-table-v2>

    <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>
    <div *ngIf="data.length==0" class="sl-empty">
      <i class="fas fa-inbox"></i>
      <span>尚無短網址資料</span>
    </div>
  </div>

  <!-- ===== Tab 1：每日連結狀態 ===== -->
  <div *ngIf="now=='1'" class="sl-panel">
    <div class="sl-daily-header">
      <div class="sl-filter-row">
        <label class="sl-filter-label">選擇連結：</label>
        <select class="form-control sl-filter-select" [(ngModel)]="selected_shortlink">
          <option value="">-- 全部連結（總覽）--</option>
          <option *ngFor="let item of all_shortlinks" [value]="item.id">
            {{item.title}}
          </option>
        </select>
        <label class="sl-filter-label ml-3">平台：</label>
        <select class="form-control sl-filter-os" [(ngModel)]="os_type">
          <option value="">全部</option>
          <option value="android">Android</option>
          <option value="ios">iOS</option>
          <option value="pc">PC</option>
        </select>
      </div>
      <div class="sl-filter-row mt-2">
        <label class="sl-filter-label">日期區間：</label>
        <input type="date" class="form-control sl-filter-date" [(ngModel)]="date_start" min="2026-03-01">
        <span class="sl-filter-sep">~</span>
        <input type="date" class="form-control sl-filter-date" [(ngModel)]="date_end">
        <button class="btn btn-primary btn-sm sl-btn-query" (click)="query_daily()">
          <i class="fas fa-search mr-1"></i>查詢
        </button>
      </div>
    </div>

    <div class="sl-chart-box">
      <highcharts-chart
        id="sl-daily-chart"
        [Highcharts]="Highcharts"
        [options]="lineOptions"
        [(update)]="updateFlag"
        [oneToOne]="true"
        style="display:block;width:100%;height:380px;">
      </highcharts-chart>
    </div>

    <div *ngIf="daily_table_data.length > 0" class="sl-daily-table">
      <div class="sl-section-title">
        <i class="fas fa-table mr-1"></i>每日明細數據
      </div>
      <app-table-v2 [type]="1" [tcontent]="daily_tcontent" [data]="daily_display_data">
        <ng-template let-post #operation_dk></ng-template>
      </app-table-v2>
      <app-pagnation (callback)="daily_callback($event)" [data]="daily_pageobjstr"></app-pagnation>
    </div>

    <div *ngIf="!loading && daily_table_data.length==0" class="sl-empty">
      <i class="fas fa-chart-bar"></i>
      <span>尚無統計資料</span>
    </div>
  </div>

</div>

<!-- ===== Modal：新增/編輯 & 圖表 ===== -->
<div
  *ngIf="edit_data"
  class="modal fade bd-example-modal-lg"
  tabindex="-1"
  role="dialog"
  data-keyboard="false"
  data-backdrop="static"
  aria-labelledby="myExtraLargeModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg">

    <!-- 表單（act=='0'） -->
    <div class="modal-content sl-modal-card" *ngIf="act=='0'">
      <div class="modal-header sl-modal-header">
        <h5 class="modal-title">
          <i class="fas fa-link mr-2"></i>
          {{edit_data.id ? '編輯短網址' : '新增短網址'}}
        </h5>
      </div>
      <div class="modal-body">

        <div class="form-group row sl-form-row">
          <label class="col-sm-3 col-form-label sl-form-label">標題</label>
          <div class="col-sm-9">
            <input type="text"
              [(ngModel)]="edit_data.title"
              class="form-control"
              placeholder="請輸入標題">
          </div>
        </div>

        <!-- 中文顯示名稱（新） -->
        <div class="form-group row sl-form-row">
          <label class="col-sm-3 col-form-label sl-form-label">
            中文顯示名稱
            <small class="d-block text-muted" style="font-weight:normal;font-size:11px;">選填，附加於網址後</small>
          </label>
          <div class="col-sm-9">
            <input type="text"
              [(ngModel)]="edit_data.link_text"
              class="form-control"
              placeholder="輸入中文（例如：推薦活動、新人優惠）"
              (ngModelChange)="updateEncodedLabel()">
          </div>
        </div>

        <div class="form-group row sl-form-row">
          <label class="col-sm-3 col-form-label sl-form-label">Android 連結</label>
          <div class="col-sm-9">
            <input type="text"
              [(ngModel)]="edit_data.android_link"
              class="form-control"
              placeholder="https://...">
          </div>
        </div>

        <div class="form-group row sl-form-row">
          <label class="col-sm-3 col-form-label sl-form-label">iOS 連結</label>
          <div class="col-sm-9">
            <input type="text"
              [(ngModel)]="edit_data.ios_link"
              class="form-control"
              placeholder="https://...">
          </div>
        </div>

        <div class="form-group row sl-form-row">
          <label class="col-sm-3 col-form-label sl-form-label">PC 連結</label>
          <div class="col-sm-9">
            <input type="text"
              [(ngModel)]="edit_data.web_link"
              class="form-control"
              placeholder="https://...">
          </div>
        </div>

        <div class="form-group row sl-form-row">
          <label class="col-sm-3 col-form-label sl-form-label">備註</label>
          <div class="col-sm-9">
            <input type="text"
              [(ngModel)]="edit_data.memo"
              class="form-control"
              placeholder="備註（選填）">
          </div>
        </div>

        <div class="form-group row sl-form-row">
          <label class="col-sm-3 col-form-label sl-form-label">狀態</label>
          <div class="col-sm-9 sl-status-group">
            <label class="sl-radio-label">
              <input type="radio" name="status" [(ngModel)]="edit_data.is_enable" value="1">
              <span class="sl-radio-badge badge-on">上架</span>
            </label>
            <label class="sl-radio-label">
              <input type="radio" name="status" [(ngModel)]="edit_data.is_enable" value="0">
              <span class="sl-radio-badge badge-off">下架</span>
            </label>
            <label class="sl-radio-label" *ngIf="edit_data.id!=null">
              <input type="radio" name="status" [(ngModel)]="edit_data.is_enable" value="-1">
              <span class="sl-radio-badge badge-del">刪除</span>
            </label>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" (click)="save(0)" class="btn btn-primary" data-dismiss="modal">
          <i class="fas fa-save mr-1"></i>確認儲存
        </button>
        <button type="button" (click)="init_list()" class="btn btn-secondary" data-dismiss="modal">
          <i class="fas fa-times mr-1"></i>取消
        </button>
      </div>
    </div>

  </div>
</div>

<app-spinner [loading]="loading"></app-spinner>

<div *ngIf="showCopiedToast" class="sl-toast">
  <i class="fas fa-check-circle mr-1"></i>已複製連結
</div>
